import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import ContentRow from "./components/ContentRow";
import VideoPlayer from "./components/VideoPlayer";
import {
  getTrending,
  getNetflixOriginals,
  getTopRated,
  getActionMovies,
  getComedyMovies,
  getHorrorMovies,
  getRomanceMovies,
  getDocumentaries,
  searchContent,
} from "./services/tmdb";

const Home = () => {
  const [trending, setTrending] = useState([]);
  const [originals, setOriginals] = useState([]);
  const [topRated, setTopRated] = useState([]);
  const [action, setAction] = useState([]);
  const [comedy, setComedy] = useState([]);
  const [horror, setHorror] = useState([]);
  const [romance, setRomance] = useState([]);
  const [documentaries, setDocumentaries] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [currentVideo, setCurrentVideo] = useState(null);
  const [videoTitle, setVideoTitle] = useState('');
  const [isSearching, setIsSearching] = useState(false);

  useEffect(() => {
    loadContent();
  }, []);

  const loadContent = async () => {
    try {
      const [
        trendingData,
        originalsData,
        topRatedData,
        actionData,
        comedyData,
        horrorData,
        romanceData,
        docsData,
      ] = await Promise.all([
        getTrending(),
        getNetflixOriginals(),
        getTopRated(),
        getActionMovies(),
        getComedyMovies(),
        getHorrorMovies(),
        getRomanceMovies(),
        getDocumentaries(),
      ]);

      setTrending(trendingData);
      setOriginals(originalsData);
      setTopRated(topRatedData);
      setAction(actionData);
      setComedy(comedyData);
      setHorror(horrorData);
      setRomance(romanceData);
      setDocumentaries(docsData);
    } catch (error) {
      console.error('Error loading content:', error);
    }
  };

  const handleSearch = async (query) => {
    if (query.trim() === '') {
      setIsSearching(false);
      setSearchResults([]);
      return;
    }

    setIsSearching(true);
    try {
      const results = await searchContent(query);
      setSearchResults(results);
    } catch (error) {
      console.error('Error searching:', error);
    }
  };

  const handlePlayTrailer = (videoKey, title) => {
    setCurrentVideo(videoKey);
    setVideoTitle(title);
  };

  const handleCloseVideo = () => {
    setCurrentVideo(null);
    setVideoTitle('');
  };

  return (
    <div className="bg-[#141414] min-h-screen">
      <Navbar onSearch={handleSearch} />
      
      {!isSearching && <Hero onPlayTrailer={handlePlayTrailer} />}
      
      <div className="relative -mt-32 z-10">
        {isSearching ? (
          <ContentRow
            title="Search Results"
            movies={searchResults}
            onPlayTrailer={handlePlayTrailer}
          />
        ) : (
          <>
            <ContentRow
              title="Trending Now"
              movies={trending}
              onPlayTrailer={handlePlayTrailer}
            />
            <ContentRow
              title="BingeBox Originals"
              movies={originals}
              onPlayTrailer={handlePlayTrailer}
            />
            <ContentRow
              title="Top Rated"
              movies={topRated}
              onPlayTrailer={handlePlayTrailer}
            />
            <ContentRow
              title="Action Movies"
              movies={action}
              onPlayTrailer={handlePlayTrailer}
            />
            <ContentRow
              title="Comedies"
              movies={comedy}
              onPlayTrailer={handlePlayTrailer}
            />
            <ContentRow
              title="Horror Movies"
              movies={horror}
              onPlayTrailer={handlePlayTrailer}
            />
            <ContentRow
              title="Romance"
              movies={romance}
              onPlayTrailer={handlePlayTrailer}
            />
            <ContentRow
              title="Documentaries"
              movies={documentaries}
              onPlayTrailer={handlePlayTrailer}
            />
          </>
        )}
      </div>

      <VideoPlayer
        videoKey={currentVideo}
        title={videoTitle}
        onClose={handleCloseVideo}
      />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
